
import { takeEvery } from '@zaibot/fsa-saga';
import 'arrayq';

import { fork, put } from '../redux-saga';
import { questionaddresseeResource, questionaddresseeEditor, questionaddresseeBatch } from './resource';

import AUTHENTICATED from '../auth/actions/AUTHENTICATED';
import LOGGEDOUT from '../auth/actions/LOGGEDOUT';
import ADDRESSEE_LOADED from './actions/ADDRESSEE_LOADED';
import ADDRESSEE_NOT_LOADED from './actions/ADDRESSEE_NOT_LOADED';
import { IQuestionAddressee } from '../types';
import ADDRESSEE_UPDATED from './actions/ADDRESSEE_UPDATED';
import ADDRESSEE_CREATED from './actions/ADDRESSEE_CREATED';
import { isType } from '@zaibot/fsa';

export function* rootSaga(): Iterable<any> {
    yield fork(questionaddresseeResource.saga);
    yield fork(questionaddresseeEditor.saga);
    yield fork(questionaddresseeBatch.saga);
    yield fork(signalQuestionaddresseeWhenAuthenticated);
    yield fork(signalQuestionaddresseeReset);     
    yield fork(signalLoadAllQuestionaddresseeSuccess);
    yield fork(signalLoadAllQuestionaddresseeNotSuccess);
    yield fork(signalQuestionaddresseeUpdateSuccess);
    yield fork(signalQuestionaddresseeCreateSuccess);       
    yield fork(signalQuestionaddresseeCreateCancel);
    yield fork(signalQuestionaddresseeUpdateCancel);           
}

function* signalLoadAllQuestionaddresseeSuccess() {
    yield takeEvery<any,any>([ questionaddresseeResource.actions.LIST_SUCCESS, 
        ], function*(action){
            if (isType(action, questionaddresseeResource.actions.LIST_SUCCESS)) { 
                yield put(ADDRESSEE_LOADED({}));
                let addressees = action.payload.list;
                if (addressees&&addressees.qCount()>0) {
                    yield put(questionaddresseeEditor.actions.READ_CONTINUE({item: addressees[0]}));
                }
            }
    });
}

function* signalLoadAllQuestionaddresseeNotSuccess() {
    yield takeEvery<any,any>([ questionaddresseeResource.actions.LIST_FAILURE, 
        ], function*(action){
            if (isType(action, questionaddresseeResource.actions.LIST_FAILURE)) { 
                yield put(ADDRESSEE_NOT_LOADED({}));
            }
    });
}

function* signalQuestionaddresseeCreateSuccess() {
    yield takeEvery<any,any>([ questionaddresseeResource.actions.CREATE_SUCCESS, 
    ], function*(action){
        if (isType(action, questionaddresseeResource.actions.CREATE_SUCCESS)) { 
            const addressee: IQuestionAddressee = action.payload.item;
            yield put(ADDRESSEE_CREATED({questionaddressee: addressee}));
        }
    });
}

function* signalQuestionaddresseeUpdateSuccess() {
    yield takeEvery<any,any>([ questionaddresseeResource.actions.UPDATE_SUCCESS, 
    ], function*(action){
        if (isType(action, questionaddresseeResource.actions.UPDATE_SUCCESS)) { 
            const addressee: IQuestionAddressee = action.payload.item;
            yield put(ADDRESSEE_UPDATED({questionaddressee: addressee}));
        }
    });
}

function* signalQuestionaddresseeCreateCancel() {
    yield takeEvery<any,any>([ questionaddresseeEditor.actions.CREATE_CANCEL, 
    ], function*(action){
        if (isType(action, questionaddresseeEditor.actions.CREATE_CANCEL)) { 
            yield put(questionaddresseeResource.actions.LIST({}));
        }
    });
}

function* signalQuestionaddresseeUpdateCancel() {
    yield takeEvery<any,any>([ questionaddresseeEditor.actions.UPDATE_CANCEL, 
    ], function*(action){
        if (isType(action, questionaddresseeEditor.actions.UPDATE_CANCEL)) { 
            yield put(questionaddresseeResource.actions.LIST({}));
        }
    });
}

function* signalQuestionaddresseeWhenAuthenticated() {
    yield takeEvery([AUTHENTICATED], 
                     function*(){                                
        yield put(questionaddresseeResource.actions.LIST({}));
    });
}

function* signalQuestionaddresseeReset() {
    yield takeEvery(LOGGEDOUT, function*() {
        yield put(questionaddresseeResource.actions.RESET({ }));
    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/questionaddressee/sagas.tsx